// useProfileScreen.ts
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getApi } from "../../api/api";
import { setBonusData } from "../../store/slices/bonusSlice";
import { setOrders } from "../../store/slices/orderSlice";
import { selectIsOnline } from "../../store/slices/networkSlice";
import { selectCurrentUser } from "../../store/slices/currentUserSlice";
import {
  selectBonusBalance,
  selectBonusPercent,
} from "../../store/slices/bonusSlice";
import { selectOrders } from "../../store/slices/orderSlice";
import { selectComplexOrderList } from "../../store/slices/complexOrderListSlice";

export const useProfileScreen = () => {
  const dispatch = useDispatch();
  const [api] = useState(getApi());

  const isOnline = useSelector(selectIsOnline);
  const currentUser = useSelector(selectCurrentUser);
  const bonusBalance = useSelector(selectBonusBalance);
  const bonusPercent = useSelector(selectBonusPercent);
  const orders = useSelector(selectOrders);
  const complexOrders = useSelector(selectComplexOrderList);

  const getData = useCallback(async () => {
    if (!isOnline) return;

    try {
      const [bonusResult, ordersResult] = await Promise.all([
        api.getBonusBalance(),
        api.getOrderList(),
      ]);

      if (bonusResult) dispatch(setBonusData(bonusResult));
      if (ordersResult) dispatch(setOrders(ordersResult));
    } catch (error) {
      console.error("Ошибка загрузки профиля:", error);
    }
  }, [api, dispatch, isOnline]);

  useEffect(() => {
    getData();
  }, [getData]);

  return {
    phone: currentUser?.phone_number || "",
    bonusBalance,
    bonusPercent,
    ordersCount: orders?.length || 0,
    projectsCount: complexOrders?.length || 0,
    currentUser,
  };
};
